import React from 'react';
import backgroundImage from "./images/Studio-6.jpg";
import {Container, Row} from "react-bootstrap";
import Contact from "./components/Contact";
import Management from "./components/Label/Management";
import Artists from "./components/Label/Artists";

const Label = () => {
    return (
        <div
            style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                minHeight: '100vh',
                color: 'white',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
            <div className="scrollable-container">
                <Container className="py-5">
                    <Row className="g-4" id="contact">
                        <Artists/>
                    </Row>

                </Container>
                <Container className="py-5">
                    <Row className="g-4" id="contact">
                        <Management/>
                    </Row>
                </Container>
            </div>
        </div>
);
};

export default Label;